import { ObjectUtilities } from '@awayfl/swf-loader';
export var nativeFunctions = ObjectUtilities.createMap();
